export default "__VITE_ASSET__DR6PT2Gw__"